import {keyToCoords} from "./keyToCoords";
import {HEX_DIRECTIONS} from "../../constants/geometry";
import {coordsToKey} from "./coordsToKey";

export const getNeighborHexKeys = (hexKey) => {
  const [q, r] = keyToCoords(hexKey);

  return HEX_DIRECTIONS.map(([nq, nr]) => coordsToKey(q + nq, r + nr));
};